export enum SorterKeyEnum {
  Sortby = 'sortBy',
  SortOrder = 'sortOrder',
}
